import Seo from "../seo/Seo";
import { pageMetadata } from "../seo/metadata";
import { pageSchema } from "../seo/schema";
import QRCode from "react-qr-code";

import Navbar from "../components/Navbar";
import FooterSection from "../components/sections/FooterSection";
import GooglePlayIcon from "../components/icons/GooglePlayIcon";
import {
	APP_STORE_LANDING_URL,
	GOOGLE_PLAY_LANDING_URL,
} from "../constants/urls";

function AppleIcon() {
	return (
		<svg className="w-12 h-12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
			<path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
		</svg>
	);
}

const stores = [
	{
		name: "App Store",
		platform: "iPhone & Apple Watch",
		description: "Track every point from your wrist and review the full match on your iPhone.",
		href: APP_STORE_LANDING_URL,
		icon: <AppleIcon />,
		button: "Download for iOS",
	},
	{
		name: "Google Play",
		platform: "Android",
		description: "Keep score, save your matches and follow your progress from your Android phone.",
		href: GOOGLE_PLAY_LANDING_URL,
		icon: <GooglePlayIcon className="w-12 h-12" />,
		button: "Download for Android",
	},
];

export default function Download() {
	return (
		<>
			<Navbar />
		<main id="main-content" className="min-h-screen" style={{ background: "var(--color-night)", color: "var(--color-on-night)" }} aria-labelledby="download-heading">
			<Seo metadata={pageMetadata.download} structuredData={pageSchema(pageMetadata.download, [{ name: "Home", path: "/" }, { name: "Download", path: "/download" }])} />

			<section className="download-page pt-28 md:pt-36 pb-20 md:pb-28">
				<div className="container mx-auto px-4 sm:px-6">
					<header className="max-w-4xl mx-auto text-center mb-12 md:mb-16">
						<p className="font-display font-bold uppercase mb-4" style={{ color: "var(--color-accent)", fontSize: "var(--text-sm)", letterSpacing: "var(--tracking-label)" }}>
							Choose your court companion
						</p>
						<h1 id="download-heading" className="font-display font-bold uppercase" style={{ fontSize: "var(--text-display)", lineHeight: "var(--lh-tight)" }}>
							Download Racketly.<br /><span style={{ color: "var(--color-accent)" }}>Track every point.</span>
						</h1>
						<p className="mt-6 text-lg md:text-xl max-w-2xl mx-auto" style={{ color: "var(--color-on-night-muted)", lineHeight: "var(--lh-body)" }}>
							Choose your device below or scan a QR code from your phone. Both links take you directly to the official store listing.
						</p>
					</header>

					<div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto">
						{stores.map((store) => (
							<article key={store.name} className="download-card flex flex-col p-7 sm:p-9">
								<div className="flex items-start justify-between gap-6 mb-8">
									<div className="download-card__icon flex items-center justify-center">
										{store.icon}
									</div>
									<span className="font-display font-bold uppercase text-right" style={{ color: "var(--color-accent)", fontSize: "var(--text-xs)", letterSpacing: "var(--tracking-label)" }}>
										{store.platform}
									</span>
								</div>

								<h2 className="font-display font-bold uppercase" style={{ fontSize: "var(--text-3xl)", lineHeight: "var(--lh-snug)" }}>{store.name}</h2>
								<p className="mt-4 mb-8" style={{ color: "var(--color-on-night-muted)", lineHeight: "var(--lh-body)" }}>{store.description}</p>

								<div className="mt-auto grid sm:grid-cols-[1fr_auto] gap-5 items-center">
									<a href={store.href} target="_blank" rel="noopener noreferrer" className="btn-slab btn-slab--accent lift w-full">
										{store.button}
									</a>
									<div className="download-card__qr" aria-label={`QR code for ${store.name}`}>
										<QRCode value={store.href} size={88} fgColor="#071427" bgColor="#f5f0e8" />
									</div>
								</div>
							</article>
						))}
					</div>

					<p className="mt-8 text-center text-sm" style={{ color: "var(--color-on-night-muted)" }}>
						Store availability and features can vary by device and region.
					</p>
				</div>
			</section>
		</main>
			<FooterSection isDark={true} />
		</>
	);
}
